export default __webpack_public_path__ + "static/media/streamcam.69e925ce.png";